<template>
<div>
<querytitle>
  <template slot="queryleft">
      <div>定义角色及对应的操作权限</div>
    </template>
  <template slot="queryright">
    <el-button type="primary" size="mini" @click="add()">新增</el-button>
  </template>
</querytitle>
<el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
<el-table-column prop="role_code" label="角色编号" width="80"></el-table-column>
  <el-table-column prop="role_name" label="角色名称" width="200"></el-table-column>
  <el-table-column prop="role_rights" label="权限集合" ></el-table-column>
  <el-table-column fixed="right" label="操作" width="150">
    <template slot-scope="scope">
     <el-link icon="el-icon-check" @click="edit(scope)" type="success" size="mini">修改</el-link>
     <el-link icon="el-icon-close" type="danger" size="mini" @click="del(scope)">删除</el-link>
    </template>
  </el-table-column>
</el-table>
<el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="rt">
</el-pagination>
<el-dialog title="角色定义" :visible="dialogFormVisible" :show-close="false" width="80%" @opened="onloadchecktree">
<el-form label-width="100px">
  <el-form-item label="角色编号:">
    <el-input v-model="itemedit.role_code" @input="inputmethod()" placeholder="请输入内容"></el-input>
  </el-form-item>
  <el-form-item label="角色名称:">
    <el-input v-model="itemedit.role_name" @input="inputmethod()" placeholder="请输入内容"></el-input>
  </el-form-item>
</el-form>
<div style="height:500px;overflow:auto;background:#EEEEEE;">
<el-tree ref="rightstree"
  :data="treelist"
  show-checkbox
  default-expand-all
  node-key="ID"
  :check-strictly="IsStrictMode"
  :props="userProps">
</el-tree>
</div>
<div slot="footer" class="dialog-footer">
 <el-button @click="dialogFormVisible=false">取 消</el-button>
 <el-button type="primary" @click="postdata()">确 定</el-button>
</div>

</el-dialog>
</div>
</template>
<script>
import querytitle from '@/components/querytitle'
import fileimportbutton from '@/components/fileimportbutton'
export default {
components: {
  querytitle,fileimportbutton
},
data() {
  return {
    hh: 500,
    loading:false,
    addflag: false,
    itemlist: [],
    itemindex: 0,
    itemedit: {},
    dialogFormVisible: false,
    rt: 0,
    currentPage: 1,
    pagesize: 10,
    pars:{objname:'sys_roles'},
    querykey:"",
    treelist:[],
    userProps:{
       label:'NAME',
       children:'children'    
    },
    CheckedData:[],
    IsStrictMode:true,
  };
},
created() {
  this.hh = document.documentElement.clientHeight - 220;
  this.getlist();
  this.gettreelist();
 
},
methods: {
  add() {
    this.IsStrictMode=true
    this.addflag = true;
    this.itemedit.role_code=''
    this.itemedit.role_name=''
    this.CheckedData=[];
    this.dialogFormVisible = true;
  },
  edit(par) {
    this.IsStrictMode=true
    this.addflag = false;
    this.itemindex = par.$index;
    this.itemedit = Object.assign({}, par.row);
    this.CheckedData=this.itemedit.role_rights.split(',');
    this.dialogFormVisible = true;
    
  },
  onloadchecktree(){
    this.$refs.rightstree.setCheckedKeys(this.CheckedData)
  },
  del: function (par) {
    let that = this;
    that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        var pars = {objname: "sys_roles",model: par.row};
        that.PostData("Common/DEL",pars,function (res) {
            if (res.data.error_code != 0) {
             that.$alert(res.data.message, {title: "错误"});
             return;
             }
             that.itemlist.splice(par.$index, 1);
          },function (err) {
            that.$alert(err, {title: "错误",type: 'error'});
          }
        );
      })
      .catch(() => {});
    },
    postdata() {
      let that = this;
      if (!that.itemedit.role_code) {
        that.$alert("代码不能为空", {title: "提示"});return;
      }
       that.itemedit.role_rights=this.$refs.rightstree.getCheckedKeys().join(',');
      let pars = {objname: "sys_roles",model: Object.assign({}, that.itemedit)};
      if (that.addflag) {
          that.PostData("Common/ADD",pars,function (res) {
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {title: "错误"});return;
            }
            that.itemlist.push(pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      } else {
        that.PostData("Common/EDIT",pars,function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, {title: "错误"});return;
          }
            that.$set(that.itemlist, that.itemindex, pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      }
    },
    getlist() {
        let that = this
        let wherestring = []
        if(this.querykey){
          wherestring = [{field: 'role_code',sym: 'like',val: this.querykey,oper: 'or'},]
        }
        let pars = {objname: "sys_roles",wheres: wherestring,PageSize: that.pagesize,CurrentPage: that.currentPage}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.itemlist = res.data.data
          that.rt = res.data.rowTotal
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
     gettreelist() {
        let that = this
        let wherestring = []
        if(this.querykey){
          wherestring = [{field: 'ID',sym: 'like',val: this.querykey,oper: 'or'},]
        }
        let pars = {}
        that.PostData("SYS/GetMenus", pars,function (res) { 
           that.treelist=res.data.data
        },
        function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
  }
};
</script>
